module.exports = __webpack_public_path__ + "img/secure.d9c99cff.svg";